<template>
    <!-- <v-container class="ma-0 pa-0"> -->
    <div class="d-flex darken">
        <v-scale-transition>
            <div v-if="isMounted" class="white--text ma-auto" align="center" justify="center">
                <!-- <h1 class="display-4 font-weight-bold mx-0 px-0"> -->
                <!-- <p :class="[sloganDisplay]"> -->
                <p class="text-md-h1 text-h5">
                    {{display}}<span :style="{visibility: showDot ? 'visible': 'hidden'}">_</span>
                </p>
                <p v-if="$store.getters.selectedLanguage.short === 'EN'" class="text-md-body-1 text-body-2" align="center" justify="center">
                    Through innovation and creative thinking we find solutions to your challenges. By either optimizing existing solutions or producing entirely new solutions.
                </p>
                <p v-if="$store.getters.selectedLanguage.short === 'NO'" class="text-md-body-1 text-body-2" align="center" justify="center">
                    Gjennom innovasjon og kreativ tankegang finner vi løsninger på dine utfordringer. Gjennom å enten optimalisere eksisterende løsninger, eller å oppfinne helt nye løsninger.
                </p>
            </div>

        </v-scale-transition>
    </div>
    <!-- </v-container> -->

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'


export default {
    name: "Home",
    data() {
        return {
            isMounted: false,
            startPause: 3500,
            stopPause: 5000,
            showDot: true,
            index: 0,
            text: "Reinventing the invented",
            display: "",
            direction: "forward",
            forwardTimer: () => { return Math.random()*600; },
            reverseTimer: () => { return 50; },
        };
    },
    //   components: {
    //     HelloWorld
    //   },
    methods: {
        textTyper() {
            setTimeout(() => {
                let index;
                let direction = this.direction;
                if(direction == "forward"){
                    index = this.index++;
                }
                else{
                    index = this.index--;
                }
                let text = this.text;


                if(direction == "forward" && index > text.length){
                    // this.$set(this, "index", 0);
                    setTimeout(() => {
                        this.$set(this, "direction", "reverse");
                        this.textTyper();
                    }, (this.stopPause));
                    return;
                }

                if(direction == "reverse" && index < 0){
                    // this.$set(this, "index", 0);
                    setTimeout(() => {
                        this.$set(this, "direction", "forward");
                        this.textTyper();
                    }, (this.stopPause));
                    return;
                }

                this.display = text.substring(0, index);
                this.textTyper();
            }, this.direction == "forward" ? this.forwardTimer() : this.reverseTimer() );
        }
    },
    mounted() {
        this.isMounted = true;
        setInterval(() => {
            this.showDot = !this.showDot;
        }, 750);

        setTimeout(() => {
            this.textTyper();
        }, this.startPause);
    }
};
</script>

<style lang="scss">
.darken {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../assets/photo-1553341640-6b28ff92098a.jpg);
    // background-image: ;
    // background-size: contain;
    background-position: center;
    width: 100%;
    height: 100%;
    // opacity: 50%;
}
</style>
